import React, { FC } from "react";
import { Container, ServiceInfo, ServiceName, ServiceSubheader } from "./styles";
import { Tooltip } from "components/atoms/Tooltip";
import Image from "next/image";
import { useWindowSize } from "@hooks";
import styled from "styled-components";
import { CountryService, CountryServices } from "components/pages/GlobalRewards/types";

interface AvailableServices {
  services: CountryServices;
}

interface IndividualService {
  service: CountryService;
  serviceName: string;
  isLast: boolean;
  responsiveImageSize: number;
}

const IndividualService: FC<IndividualService> = ({
  serviceName,
  service,
  isLast,
  responsiveImageSize,
}) => {
  return (
    <Container pb={isLast ? "0" : "1.5rem"} key={serviceName}>
      <Image
        height={responsiveImageSize}
        width={responsiveImageSize}
        alt={`${serviceName} icon`}
        src={service.onRequest ? "/static/icons/Add.svg" : "/static/icons/PurpleCheck.svg"}
      />
      <ServiceInfo>
        <ServiceName>{serviceName.toUpperCase()}</ServiceName>
        {service.onRequest ? <ServiceSubheader>At additional cost</ServiceSubheader> : null}
      </ServiceInfo>
    </Container>
  );
};

const AvailableServices: FC<AvailableServices> = ({ services }) => {
  const [width] = useWindowSize();
  const isMobile = width < 720;
  const isTightMobile = width < 540;
  const responsiveImageSize = isMobile ? 32 : 40;

  return (
    <>
      <Container>
        <Image
          height={responsiveImageSize}
          width={responsiveImageSize}
          alt="ESG icon"
          src="/static/icons/PurpleCheck.svg"
        />
        <Relative>
          <ServiceName>ESG Donations</ServiceName>
          <Tooltip
            tooltipDesktopWidth="16rem"
            inverted
            iconPositioning={{ left: "11rem", top: "0.7rem" }}
            infoBoxPositioning={
              isTightMobile
                ? { left: "2rem", bottom: "-11rem" }
                : { left: "13rem", bottom: "-7rem" }
            }
            tipPositioning={
              isTightMobile
                ? {
                    top: "-9%",
                    left: "53.5%",
                    marginLeft: "0.5rem",
                    borderWidth: "0.5rem",
                    transform: "rotate(180deg)",
                  }
                : {
                    top: "28%",
                    left: "-8%",
                    marginLeft: "0.5rem",
                    borderWidth: "0.5rem",
                    transform: "rotate(90deg)",
                  }
            }
          >
            Plant trees, Donate meals and clean water, or remove plastic from oceans.
          </Tooltip>
        </Relative>
      </Container>
      {Object.entries(services).map(([serviceName, service], index) => {
        const isLast = index === Object.entries(services).length - 1;

        if (!service.live) {
          return null;
        }

        return (
          <IndividualService
            key={serviceName}
            service={service}
            serviceName={serviceName}
            isLast={isLast}
            responsiveImageSize={responsiveImageSize}
          />
        );
      })}
    </>
  );
};

export default AvailableServices;

export const Relative = styled.div`
  position: relative;
`;
